import { Button } from 'semantic-ui-react';
import './styles.css';

type ExtractionIndicationPropsType = {
    loading: boolean;
    disabled: boolean;
    handleOpenExtractionModal: () => void;
};

const ExtractionIndication = ({ loading, disabled, handleOpenExtractionModal }: ExtractionIndicationPropsType) => {
    return (
        <div className="extraction-indication">
            <Button loading={loading} disabled={disabled} primary onClick={handleOpenExtractionModal}>
                Current Extraction
            </Button>
        </div>
    );
};

export default ExtractionIndication;
